import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function PainPointsSection() {
  const pains = [<span data-id="element-284">
      Lees nombres como{' '}
      <span className="font-bold text-gray-900" data-id="element-285">"Mar Rojo"</span> o{' '}
      <span className="font-bold text-gray-900" data-id="element-286">"Monte Sinaí"</span> y siguen
      siendo <span className="italic text-gray-600" data-id="element-287">palabras abstractas</span>{' '}
      sin ninguna imagen real en tu mente.
    </span>, <span data-id="element-288">
      Llevas años estudiando la Biblia pero{' '}
      <span className="font-bold text-burgundy-700 underline-emphasis" data-id="element-289">
        nunca has comprendido la geografía
      </span>{' '}
      que moldeó cada acontecimiento.
    </span>, <span data-id="element-290">
      Quieres recursos visuales de calidad pero son{' '}
      <span className="font-bold text-gray-900" data-id="element-291">carísimos</span>,{' '}
      <span className="italic" data-id="element-292">incompletos</span> o simplemente{' '}
      <span className="underline-subtle" data-id="element-293">no existen en español</span>.
    </span>, <span data-id="element-294">
      Sientes que existe una{' '}
      <span className="font-bold text-burgundy-700" data-id="element-295">"brecha"</span> entre lo que
      lees y lo que realmente entiendes porque{' '}
      <span className="highlight-warm font-semibold" data-id="element-296">
        te falta el contexto visual
      </span>
      .
    </span>, <span data-id="element-297">
      No puedes pagar <span className="font-bold text-gray-900" data-id="element-298">$5,000</span> en
      un viaje a Tierra Santa ni{' '}
      <span className="font-bold text-gray-900" data-id="element-299">$247</span> en un curso de
      geografía bíblica para{' '}
      <span className="italic font-medium" data-id="element-300">ver lo que lees</span>.
    </span>];
  return <section className="py-8 md:py-16 bg-white content-section" data-id="element-301">
      <div className="max-w-3xl mx-auto px-4 sm:px-6" data-id="element-302">
        <div className="text-center mb-6 md:mb-12" data-id="element-303">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-304">
            Este Recurso Es Para Ti Si…
          </h2>
          <div className="w-24 h-1 bg-burgundy-600 mx-auto" data-id="element-305"></div>
        </div>

        <div className="space-y-2.5 md:space-y-4" data-id="element-306">
          {pains.map((pain, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          delay: Math.min(index * 0.1, 0.3),
          duration: 0.4
        }} className="flex items-start p-3 md:p-4 bg-red-50 rounded-lg border-l-4 border-red-500 shadow-sm" data-id="element-307">
              <XCircle className="w-6 h-6 text-red-600 flex-shrink-0 mt-1 mr-4" data-id="element-308" />
              <p className="text-gray-800 text-base md:text-lg leading-relaxed" data-id="element-309">
                {pain}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}